module.exports = __webpack_public_path__ + "img/course.cfce9572.svg";